import { graphql } from "api/cms-website/generated";

export const TableWithCheckmarksRowFragment = graphql(/* GraphQL */ `
    fragment TableWithCheckmarksRowFragment on ComponentElementsTableWithCheckmarksRow {
        title
        columns
    }
`);
